document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("change", (event) => {
    if (
      event.target &&
      event.target.matches(
        'input[type="radio"][name^="Farbe-"], input[type="radio"][name^="Colour-"], input[type="radio"][name^="Schubladen-"], input[type="radio"][name^="Frame-"]'
      )
    ) {
      requestAnimationFrame(() => {
        const target = event.target;

        const selectedColour = (target.name.startsWith("Farbe-") || target.name.startsWith("Colour-"))
          ? target.value
          : document.querySelector(
              'input[type="radio"][name^="Farbe-"]:checked, input[type="radio"][name^="Colour-"]:checked'
            )?.value || "";

        const selectedDrawers = target.name.startsWith("Schubladen-")
          ? target.value
          : document.querySelector(
              'input[type="radio"][name^="Schubladen-"]:checked'
            )?.value || "";

        const selectedFrame = target.name.startsWith("Frame-")
          ? target.value
          : document.querySelector(
              'input[type="radio"][name^="Frame-"]:checked'
            )?.value || "";

        let selectedVariant = "";

        if (selectedFrame) {
          selectedVariant = `${selectedFrame} / ${selectedColour}`;
        } else if (selectedDrawers) {
          selectedVariant = `${selectedColour} / ${selectedDrawers}`;
        } else {
          selectedVariant = selectedColour;
        }

        handleVariantChange(selectedVariant);
      });
    }
  });
});

function handleVariantChange(selectedValue) {
  console.log(`Handling variant change for: ${selectedValue}`);
  const variant = getVariantMetafieldByTitle(selectedValue);

  if (!variant) return;

  // Update Product title
  const productTitle = document.querySelectorAll(
    ".product__info-wrapper span.product-title, #all-variants-modal span.product-title"
  );
  productTitle.forEach((title) => {
    const currentText = title.textContent;
    if (currentText.includes(" | ")) {
      title.textContent = currentText.split(" | ")[0] + " | " + selectedValue;
    } else {
      title.textContent = currentText + " | " + selectedValue; // Add " | selectedValue" if " | " is not present
    }
  });

  // Update Media
  updateGallery(variant.id);

  // Update Availability
  updateAvailability(variant);

  // Update PriceO
  updatePrice(variant);

  // Update Colour
  const colorWrapper = document.querySelector(".colour-wrapper dd");
  if (colorWrapper) {
    colorWrapper.textContent = selectedValue;
  } else {
    console.warn("Colour wrapper element not found.");
  }

  // Update Material
  updateMaterial(variant, selectedValue);

  // Update Fabric Popup Image
  updateFabricPopupImage(variant);
}

function updateAvailability(variant) {
  const availability_container = document.querySelector(".button-availability");
  if (availability_container != undefined) {
    availability_container.innerHTML = variant.availability;
  }
}
function updatePrice(variant) {
  const { price, rrp } = variant;

  if (rrp && price != rrp) {
    let reg_price = document.querySelector(
      ".fabric-popup .price-item--regular"
    );
    document.querySelector(".fabric-popup s.price-item--regular").textContent =
      rrp;
    document.querySelector(".fabric-popup .price-item--sale").textContent =
      price;
    document
      .querySelector(".fabric-popup .price")
      .classList.add("price--on-sale");
  } else {
    document.querySelector(".fabric-popup .price-item--regular").textContent =
      price;
    document
      .querySelector(".fabric-popup .price")
      .classList.remove("price--on-sale");
  }
}

function updateMaterial(variant, selectedValue) {
  const materialWrapper = document.querySelector(".material-wrapper dd");
  if (materialWrapper) {
    if (variant.metafields?.material) {
      materialWrapper.textContent = variant.metafields.material;
    } else {
      materialWrapper.textContent = "Material not available";
      console.warn(`Material not found for variant: ${selectedValue}`);
    }
  } else {
    console.warn("Material wrapper element not found.");
  }
}

function updateFabricPopupImage(variant) {
  const fabricPopupImage = document.querySelector(
    ".variant-detail__container img"
  );
  if (fabricPopupImage) {
    if (variant.featured_image) {
      fabricPopupImage.srcset = "";
      fabricPopupImage.src = variant.featured_image;
    } else {
      fabricPopupImage.src = "";
      console.warn("Fabric popup image not found for variant:", variant.title);
    }
  } else {
    console.warn("Fabric popup image element not found.");
  }
}

function getVariantMetafieldByTitle(title) {
  console.log(`Looking for variant with title: ${title}`);
  const variant = swyft_product.variants.find((v) => v.title === title);

  if (!variant) {
    console.error(`Variant with title "${title}" not found.`);
    return null;
  }

  console.log("Found variant:", variant);
  return variant;
}

// Gallery Sync Logic
function updateGallery(variantId) {
  const selectedVariant = swyft_product.variants.find(
    (variant) => variant.id === variantId
  );
  if (!selectedVariant || !selectedVariant.variant_media) {
    console.error("Variant not found or has no media.");
    return;
  }

  const imageUrls = selectedVariant.variant_media.map((media) => media.url);

  // Update each section individually
  syncImageElements(document.querySelector(".product__media-list"), imageUrls, {
    templateSelector: ".product__media-item",
    updateCallback: updateGalleryItem,
    prefix: "gallery",
  });

  syncImageElements(document.querySelector(".thumbnail-list"), imageUrls, {
    templateSelector: ".thumbnail-list__item",
    updateCallback: updateThumbnailItem,
    prefix: "thumbnail",
    variant_id: variantId,
  });

  syncImageElements(
    document.querySelector(".product-media-modal__content"),
    imageUrls,
    {
      templateSelector: "img",
      updateCallback: updateModalItem,
      prefix: "modal",
    }
  );

  const gallery = document.querySelector("media-gallery");
  gallery?.setActiveThumbnail(document.querySelector(".thumbnail-list__item"));

  const items = document.querySelectorAll(".thumbnail-list__item");
  if (items.length > 5) {
    document.querySelectorAll(".slider-button").forEach((button) => {
      button.removeAttribute("disabled");
    });
  }
}

function syncImageElements(container, urls, options) {
  const { templateSelector, updateCallback, prefix, variant_id } = options;

  // Clone the template element for new items
  const templateElement = document
    .querySelector(templateSelector)
    ?.cloneNode(true);
  if (!templateElement) {
    console.error("No template element found for cloning.");
    return;
  }

  const existingElements = Array.from(container.children);

  // Step 1: Remove excess elements
  if (existingElements.length > urls.length) {
    existingElements.slice(urls.length).forEach((item) => item.remove());
  }

  // Step 2: Update or create new elements
  urls.forEach((url, index) => {
    let element = existingElements[index];
    if (!element) {
      // Append a new cloned element if one doesn't exist
      element = templateElement.cloneNode(true);
      container.appendChild(element);
    }

    // Pass the variant_id explicitly to the callback
    updateCallback(element, url, index, prefix, variant_id);
  });
}

// Callbacks for Different Structures
function updateGalleryItem(item, url, index, prefix) {
  item.id = `${prefix}-${index}`;
  const img = item.querySelector("img");
  if (img) {
    img.src = url;
    img.alt = `Gallery Image ${index + 1}`;
  }
}

function updateThumbnailItem(item, url, index, prefix, variant_id) {
  item.id = `${prefix}-thumb-${index}`;

  const currentDataTarget = item.getAttribute("data-target");
  if (!currentDataTarget) return;

  // Replace the variant ID using regex
  let updatedDataTarget = currentDataTarget.replace(
    /file_\d+_/,
    `file_${variant_id}_`
  );
  updatedDataTarget = updatedDataTarget.replace(/_\d+$/, `_${index}`);
  item.setAttribute("data-target", updatedDataTarget);
  const img = item.querySelector("img");
  if (img) {
    img.src = url;
    img.alt = `Thumbnail ${index + 1}`;
  }

  // Clear and rebind click events
  const button = item.querySelector("button");
  if (button) {
    const cloneButton = button.cloneNode(true); // Clone to remove existing event listeners
    button.replaceWith(cloneButton); // Replace the original button
    cloneButton.addEventListener("click", () => {
      const mediaGallery = document.querySelector("media-gallery");
      if (mediaGallery) {
        mediaGallery.setActiveMedia(updatedDataTarget, false); // Call setActiveMedia on the updated target
      }
    });
  }
}

function updateModalItem(item, url, index, prefix) {
  item.id = `${prefix}-modal-${index}`;
  const img = item.querySelector("img");
  if (img) {
    img.src = url;
    img.alt = `Modal Image ${index + 1}`;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const openModalButton = document.getElementById("all-variants-modal-open");
  const modal = document.getElementById("all-variants-modal");
  const closeButtons = modal.querySelectorAll("[data-close-modal]");
  const modalContent = modal.querySelector(".modal__content");

  let focusedElementBeforeModal;

  function openModal() {
    focusedElementBeforeModal = document.activeElement;
    modal.setAttribute("aria-hidden", "false");
    modalContent.focus();
    trapFocus(modal);
    document.querySelector("body").classList.add("overflow-hidden");
  }

  function closeModal() {
    modal.setAttribute("aria-hidden", "true");
    if (focusedElementBeforeModal) {
      focusedElementBeforeModal.focus();
    }
    document.querySelector("body").classList.remove("overflow-hidden");
  }

  openModalButton?.addEventListener("click", openModal);

  // Close when close buttons or overlay are clicked
  closeButtons.forEach((button) => {
    button.addEventListener("click", closeModal);
  });

  // Close on Escape key
  document.addEventListener("keydown", function (event) {
    if (
      event.key === "Escape" &&
      modal.getAttribute("aria-hidden") === "false"
    ) {
      closeModal();
    }
  });

  // Focus trapping
  function trapFocus(element) {
    const focusableSelectors = [
      "a[href]",
      "area[href]",
      "button:not([disabled])",
      'input:not([disabled]):not([type="hidden"])',
      "select:not([disabled])",
      "textarea:not([disabled])",
      '[tabindex]:not([tabindex="-1"])',
    ];
    const focusableElements = element.querySelectorAll(
      focusableSelectors.join(",")
    );

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    element.addEventListener("keydown", function (e) {
      // Pressing Tab
      if (e.key === "Tab") {
        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      }
    });
  }
});
